export { default, LoadComponent } from "./Loading";
